export default {
  'menu.welcome': 'Chào mừng',
  'menu.home': 'Trang chủ',

  // Admin
  'menu.admin': 'Quản trị hệ thống',
  'menu.admin.service-groups': 'Lĩnh vực',
  'menu.admin.counters': 'Quầy',
  'menu.admin.assignments': 'Gán quầy - Lĩnh vực',
  'menu.admin.users': 'Người dùng',
  'menu.admin.settings': 'Cấu hình',

  // Reports
  'menu.reports': 'Báo cáo',
  'menu.reports.dashboard': 'Dashboard',
  'menu.reports.productivity-counters': 'Năng suất quầy',

  // Dashboard
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Phân tích',
  'menu.dashboard.monitor': 'Giám sát',
  'menu.dashboard.workplace': 'Không gian làm việc',

  // Forms
  'menu.form': 'Biểu mẫu',
  'menu.form.basic-form': 'Biểu mẫu cơ bản',
  'menu.form.step-form': 'Biểu mẫu từng bước',
  'menu.form.advanced-form': 'Biểu mẫu nâng cao',

  // Lists
  'menu.list': 'Danh sách',
  'menu.list.table-list': 'Bảng danh sách',
  'menu.list.basic-list': 'Danh sách cơ bản',
  'menu.list.card-list': 'Danh sách thẻ',
  'menu.list.search-list': 'Tìm kiếm',
  'menu.list.search-list.articles': 'Bài viết',
  'menu.list.search-list.projects': 'Dự án',
  'menu.list.search-list.applications': 'Ứng dụng',

  // Profile
  'menu.profile': 'Hồ sơ',
  'menu.profile.basic': 'Hồ sơ cơ bản',
  'menu.profile.advanced': 'Hồ sơ nâng cao',

  // Result
  'menu.result': 'Kết quả',
  'menu.result.success': 'Thành công',
  'menu.result.fail': 'Thất bại',

  // Exception
  'menu.exception': 'Lỗi',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',

  // Account
  'menu.account': 'Tài khoản',
  'menu.account.center': 'Trung tâm tài khoản',
  'menu.account.settings': 'Cài đặt tài khoản',
  'menu.account.logout': 'Đăng xuất',

  // Login
  'menu.login': 'Đăng nhập',
  'menu.register': 'Đăng ký',
  'menu.register-result': 'Kết quả đăng ký',
};


